import RandingStyle7 from "../../randing/RandingStyle7";

function Randing063({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle7
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/063/25010801.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/386/2.gif`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/063/25010803.png`} //질문 이미지
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/063/25010804.png`} //질문 이미지
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      qOptionImgPath={`${process.env.REACT_APP_CDN_BASE}/images/063`} // 필수!
      qOptions={["벌어진 앞니", "튀어나온 앞니", "비틀어진 앞니", "토끼이빨"]}
      formFieldColor="white"
      colorRequest="white"
      companyName="검단뉴욕치과"
      addStyle={{ marginTop: 0, width: "117.5%" }}
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/geomdan.png`}
      kakaotalk="003"
      carrotTag={true}
    />
  );
}

export default Randing063;
